import React, { forwardRef } from 'react'
import { Box, Circle, Input } from '@chakra-ui/react'

const RadioContainer = ({ children }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      {children}
    </Box>
  )
}

export const RadioInput = forwardRef(({ name, value, checked, onChange, ...props }, ref) => {
  return (
    <RadioContainer>
      <Input type="radio" name={name} value={value} checked={checked} onChange={onChange} display="none" ref={ref} />
      <Box
        as="span"
        width="30px"
        height="30px"
        border="1px solid black"
        borderRadius="50%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        transition="border-color 0.2s ease-in-out"
        _checked={{
          borderColor: '#37f091', // Cor de destaque quando marcado
        }}
        {...props}
      >
        <Circle width="12px" height="12px" bg="#37f091" borderRadius="50%" opacity={checked ? 1 : 0} transition="opacity 0.2s ease-in-out" />
      </Box>
    </RadioContainer>
  )
})
